module.exports = __webpack_public_path__ + "static/media/SVG_ring.48dec389.svg";